<p-confirmDialog />
<p-contextMenu #cm [model]="treeOptions" />
<div class="container">
  <main>
    <div class="left">
      <div class="top-align">
        <div class="title">
          <h2>Folders</h2>
          <p-button
            icon="pi fi fi-rr-folder-plus-circle"
            severity="info"
            rounded='true'
            outlined='true'
            text="true"
            size="small"
            pTooltip="New Folder"
            (onClick)="newFolder()"
          ></p-button>
        </div>
        <p-tree
          [value]="treeView$ | async"
          selectionMode="single"
          filterPlaceholder="Filter Presets"
          [trackBy]="trackByFolder"
          [contextMenu]="cm"
          [(selection)]="_pTreeBoundSeletion"
          (onNodeSelect)="onNodeSelected($event)"
          (onNodeContextMenuSelect)="onNodeSelected($event)"
          (onNodeUnselect)="onNodeUnselected($event)"
        />
      </div>
      <p-button
        label="Group Admin"
        icon="pi fi fi-rr-admin-alt"
        severity="help"
        outlined="true"
        routerLink="admin"
      />
    </div>
    <div class="right">
      <div class="top">
        <div class="title">
          <h2>Enterprise Renders</h2>
          <p>Manage and organize your RoRender projects</p>
        </div>
        <div class="button-cluster">
          @if (renderPipelineId$ | async) {
            <p-button
              label="Render Status"
              [outlined]="true"
              icon="pi pi-spin pi-cog"
              severity="success"
              (onClick)="openRenderStatus()"
            >
            </p-button>
          }
          <p-button
            label="Create Render"
            [loading]="newPipelineRequested"
            [outlined]="true"
            icon="pi pi-file-plus"
            severity="info"
            (onClick)="openPipeline()"
          ></p-button>
        </div>
          <!--(onClick)="openPipeline()"-->
          <!--[loading]="newPipelineRequested && !renderPipelineId "-->
      </div>
      <p-dataView
        [value]="(renders$ | async)?.data || []"
        [rows]="10"
        [paginator]="true"
        layout="grid"
        emptyMessage="No Renders in this folder"
      >
        <ng-template pTemplate="empty" let-emptyMessage>
          <div class="empty">
          @if ((renders$ | async)?.loading) {
            <div class="empty">
              <p-progressSpinner />
              <h1>Loading Renders...</h1>
            </div>
          }
          @else {
            <div class="filter"><i class="pi fi fi-rr-filter"></i></div>
            <h1>No Renders</h1>
            <h4>This folder is empty. Create a new render to get started</h4>
            <p-button
              label="Create Render"
              [loading]="newPipelineRequested"
              [outlined]="true"
              icon="pi pi-file-plus"
              severity="info"
              (onClick)="openPipeline()"
            ></p-button>
            }
          </div>
        </ng-template>
        <ng-template pTemplate="grid" let-renderList>
            <section class="folder-content">
              @for (item of renderList; track item.id) {
                <app-render-card
                  [renderData]="item"
                  (move)="moveCard(item)"
                  (delete)="deleteCard(item)"
                  (comments)="showComments(item)"
                  (open)="openCard(item)"
                  (clone)="cloneCard(item)"
                />
              }
            </section>
        </ng-template>
      </p-dataView>
    </div>
  </main>
</div>
<p-toast />
